import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconPersonSlash24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconPersonSlash24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M15.956 6.804a4 4 0 1 0-6.588 3.608A7 7 0 0 0 5 16.9v.86l1.542-1.542a5.5 5.5 0 0 1 4.776-4.776l1.81-1.81a2.5 2.5 0 1 1 1.104-1.104zm-1.134 5.374L8.6 18.4h8.9v-1.5a5.5 5.5 0 0 0-2.678-4.722M7.1 19.9l-1.82 1.82a.75.75 0 1 1-1.06-1.061l14.939-14.94a.75.75 0 0 1 1.06 1.061l-4.31 4.312A7 7 0 0 1 19 16.9v3z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconPersonSlash24);
